import React, {useEffect, useState} from "react";
import "react-grid-layout/css/styles.css";
import {observer} from "mobx-react";
import {useStores} from "../stores/Context";
import Sidebar from "../components/Siderbar";
import SidebarNiveaux from "../components/SidebarNiveaux"
import CreateWidget from "../components/CreateWidget";

import {DragDropContext} from "react-beautiful-dnd";
import NiveauFlash from "../components/NiveauFlash";
import URLMetier from "../components/URLMetier";
import axios from "axios";
import {v4 as uuidv4} from "uuid";
import WidgetIndicateurNiveaux from "../components/Widgets/WidgetIndicateur/WidgetIndicateurNiveaux";
import {useHistory, useParams} from "react-router-dom";

import ListeMessagesInterServices from "../components/Widgets/WidgetMessagesInterServices/ListeMessagesInterServices";
import WidgetConsignesContent from "../components/Widgets/WidgetConsignes/WidgetConsignesContent"

import Err403 from "../pages/Err403";
import PlanningActions from "../components/Widgets/WidgetPlanningActions/PlanningActions";
import ParametragesSystemeHome from "../components/ParametragesSysteme/ParametragesSystemeHome";
import ModalPrimary from "../boiteAOutils/ModalPrimary";
import {createAxiosEntrepriseInstance} from "../axiosEntreprise";
import DragDropSvg from "../boiteAOutils/SVG/DragDropSvg";
import LogoSeizoSSvg from "../boiteAOutils/SVG/LogoSeizoSSvg";

/*
 * Soketi
 */
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import BtnSecondary from "../boiteAOutils/BtnSecondary";
import BtnPrimary from "../boiteAOutils/BtnPrimary";
import ContactForm from "../components/ContactForm";
import TableauBlanc from "../components/Widgets/WidgetTableauBlanc/TableauBlanc";
import WidgetRSP from "../components/Widgets/WidgetRSP/WidgetRSP";
import RspPleinEcran from "../components/Widgets/WidgetRSP/RspPleinEcran";
import WidgetBibliothequeImages from "../components/Widgets/WidgetBibliothequeImages/WidgetBibliothequeImages";
import WidgetBibliothequeImagesContent
    from "../components/Widgets/WidgetBibliothequeImages/WidgetBibliothequeImagesContent";
import BtnTiertary from "../boiteAOutils/BtnTiertary";
import styles from "../boiteAOutils/BtnTiertary.module.scss";
import "../styles/editorHelp.scss";

const Dashboard = observer(() => {
    const params = useParams();
    const id = params.id;
    const ent = params.ent; // compatibilité ascendante (anciennes URLs /:ent/:id)
    const {uiStore, widgetStore, createWidgetStore, niveauxIndicateurStore} = useStores();
    let history = useHistory();
    const _currentToken = widgetStore.getCookie('current_apiToken') || widgetStore.getCookie((ent || '') + '_apiToken');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + _currentToken;

    const [idTotem, setidTotem] = useState();
    const [_token, setToken] = useState(widgetStore.getCookie('current_apiToken') || widgetStore.getCookie((ent || '') + '_apiToken'));
    const [err403, setErr403] = useState(false);
    const [infosEcran, setInfosEcran] = useState('');
    const [showModalDeleteAll, setShowModalDeleteAll] = useState(false);
    const [showAide, setShowAide] = useState(false);
    const [showHelpUnavailable, setShowHelpUnavailable] = useState(false);
    // #486 — Pop-up onboarding écran prédéfini : affiché une seule fois par écran (localStorage)
    const [showModalBacASable, setShowModalBacASable] = useState(false);
    const [hideBacASablePermanently, setHideBacASablePermanently] = useState(false);
    useEffect(() => {
        if (!infosEcran?.id_totem) return;
        const PREDEFINED = ['Mon écran', 'Mon premier écran'];
        if (PREDEFINED.includes(infosEcran.tot_nom)) {
            const key = 'seizo_bac_sable_' + infosEcran.id_totem;
            if (!localStorage.getItem(key)) {
                setShowModalBacASable(true);
            }
        }
    }, [infosEcran?.id_totem, infosEcran?.tot_nom]);

    const axiosEntrepriseInstance = createAxiosEntrepriseInstance(ent);
    // Récupération du cookie sous forme de chaîne
    const cookieEntreprise = widgetStore.getCookie('currentEntrepriseInfos') || widgetStore.getCookie((ent || '') + '_currentEntrepriseInfos');
    const entrepriseInfos = (() => {
        if (!cookieEntreprise) return {};
        try { return JSON.parse(cookieEntreprise); } catch (_) {
            try { return JSON.parse(decodeURIComponent(cookieEntreprise)); } catch (__) { return {}; }
        }
    })();

    /*
    * Soketi
    */
    window.Pusher = Pusher;
    useEffect(() => {
        const echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.REACT_APP_WS_KEY,
            secret: process.env.REACT_APP_WS_SECRET,
            wsHost: process.env.REACT_APP_WS_URL,
            wsPort: 6001,
            forceTLS: true,
            encrypted: true,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
            cluster: 'eu',
        });

        const connectionEvents = ['connected', 'disconnected', 'connecting', 'reconnecting', 'error'];
        connectionEvents.forEach(event => {
            echo.connector.pusher.connection.bind(event, (err) => {
                console.log(`WidgetsPosition_WS::${event}`);
            });
        });


        // Evenement pour mettre à jour en temps reel.
        echo.channel(id + '-WidgetsPosition_refreshChannel')
            .listen('Dashboard\\WidgetsPositionRefreshEvent', (res) => {
                console.log('WS::WidgetsPositionRefreshEvent');
                const user_apiToken = widgetStore.getCookie("user_apiToken");
                if (res.tokenSender !== user_apiToken) {
                    widgetStore.widgets = res.datas;
                    widgetStore.generateLayout(true);
                    // widgetStore.loadWidgets(true);
                }
            });

        echo.channel(id + '-WidgetsAvailable_refreshChannel')
            .listen('Dashboard\\WidgetsAvailableRefreshEvent', () => {
                widgetStore.loadWidgetsAvailable().catch(() => {});
            });

        // Cleanup function to unsubscribe when the component unmounts
        return () => {
            echo.disconnect();
        };
    }, []);


    useEffect(() => {
        getIfEntExist(ent).then(() => {
            if (idTotem !== id) {
                const getIfTotExist = async (_ent) => {
                    try {
                        const response = await axiosEntrepriseInstance.get(`/api/totem/${id}`);
                        return response.data;
                    } catch (e) {
                        console.log("Display not found");
                        // if idTotem not exist
                        history.push('/app');
                        return false;
                    }
                }
                getIfTotExist(ent).then((res) => {
                    if (res) {
                        widgetStore.setIdTotem(id);
                        setidTotem(id);
                        setInfosEcran(res);
                    }
                });
            }
        })
    }, []);


    const backHome = () => {
        // SaveWidgetsPositions();
        uiStore.backHome();
        // ResizeGridLayout();
        widgetStore.updateAllWidgetStatic();
        widgetStore.widgetsLayout = [];
        widgetStore.saveWidgetsPosition(false);
        history.push('/app');
    }

    const getIfEntExist = async (_ent) => {
        await widgetStore.setIdEnt(_ent).then((res) => {
            if (res === true) {
                setToken(widgetStore.getCookie('current_apiToken') || widgetStore.getCookie((ent || '') + '_apiToken'));
            } else if (res === "loggin") {
                history.push('/app');

            }
        })
    }

    const SaveWidgetsPositions = (trigWebSocket = false) => {
        widgetStore.saveWidgetsPosition(trigWebSocket);
    }

    const openHelpCreation = () => {
        setShowAide(false);
        uiStore.openCreationMode();
        createWidgetStore.resetCreateWidget();
    }

    const openHelpPhidgets = () => {
        setShowAide(false);
        uiStore.isPanelExtended = true;
    }

    const exitEditorFromHelp = () => {
        setShowAide(false);
        SaveWidgetsPositions(true);
        uiStore.backHome();
        ResizeGridLayout();
        widgetStore.updateAllWidgetStatic();
    }

    const ResizeGridLayout = () => {
        var ii = 0;

        for (let t = 0; t < 3000; t += 1000) { // probleme avec for (let t = 0; t <= 1200; t += 10) // tuto :  for (let t = 0; t <= 300; t += 10) (https://github.com/react-grid-layout/react-grid-layout/issues/933)
            ii = ii + t;
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, t)
        }
    }

    const handleOnDrop = async (result) => {
        // Opérateur de chaîne optionnel: https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Operators/Optional_chaining
        const droppableId = result?.destination?.droppableId;
        const source = result?.source?.droppableId;

        if (typeof droppableId === 'undefined') {
            return;
        }

        if (!droppableId.includes("drop")) {
            return;
        }
        let data = null, _store = null;
        let widget = null;

        let placement = result.destination.droppableId.replace("drop", "").split("_");
        placement = placement.filter(el => el !== '');

        switch (source) {
            case 'sideBar':
                data = widgetStore.widgetsAvailable.find(widget => widget.idWidget === result.draggableId);
                _store = widgetStore;
                await axios.get(process.env.REACT_APP_API_URL + '/api/widgetDefaultConfigByTypeWidget/' + data.typeWidget,
                    {headers: {"Authorization": `Bearer ${_token}`}})
                    .then((res) => {
                        widget = {
                            i: uuidv4(),
                            x: parseInt(placement[1], 10) - 1,
                            y: parseInt(placement[0], 10) - 1,
                            w: res.data.conf_min_w ? res.data.conf_min_w : 1,
                            h: res.data.conf_min_h ? res.data.conf_min_h : 1,
                            static: false
                            , typeWidget: data.typeWidget
                            , idWidget: data.idWidget
                        };
                    })
                break;
            case 'sideBarNiveaux':
                let idObjElem = uuidv4();
                data = niveauxIndicateurStore.elementaryWidgetsAvailable.find(object => object.idWidget === result.draggableId);
                _store = niveauxIndicateurStore;
                const handleDrop = await niveauxIndicateurStore.handleDropWidget(data, idObjElem);
                widget = {
                    obj_id_niveau: niveauxIndicateurStore.currentLevel.id,
                    obj_elem_id: idObjElem,
                    obj_elem_type: data.typeWidget,
                    obj_elem_pos_x: parseInt(placement[1], 10) - 1,
                    obj_elem_pos_y: parseInt(placement[0], 10) - 1,
                    obj_elem_pos_w: handleDrop.w,
                    obj_elem_pos_h: handleDrop.h,
                    // static: false,
                    typeWidget: data.typeWidget,
                    idWidget: data.idWidget,
                    config: handleDrop.config
                };
                /*
                Promesse renvoyée par SWAL dans hSandleDropWidget: NiveauxIndicateurStore.js
                Si confirmed === false => annule le drop
                 */
                if (handleDrop.isConfirmed === false) {
                    return;
                }
                break;
            default:
                return;
        }

        try {
            _store.addWidget(widget, ent);
        } catch (e) {
            //  console.error("Parsing error:", e);
        }
    }

    return !err403 ? (
            <div className={`dashboard`} style={{'--height-footer': '72px', '--footer-height': '72px'}}>
                {
                    uiStore.displayEditMode ? (
                        uiStore.isPanelOpened ? (
                            <div className={"editModeHeader"}>
                                <span className={"editModeHeaderTitle"}>Vous êtes en mode édition</span>
                                <button type={"button"}
                                        className={"editModeHeaderExitBtn"}
                                        onClick={() => {
                                            SaveWidgetsPositions(true);
                                            uiStore.backHome();
                                            ResizeGridLayout();
                                            widgetStore.updateAllWidgetStatic();
                                        }}
                                >
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <rect x="2.66602" y="1.83398" width="14.6667" height="16.3333" stroke="#002335"
                                              strokeWidth="2"/>
                                        <path d="M10.3691 13.918L6.45374 10.0026L10.378 6.07834" stroke="#002335"
                                              strokeWidth="2"/>
                                        <path d="M6.81055 9.99219L14.5478 9.98347" stroke="#002335" strokeWidth="2"/>
                                    </svg>
                                    Sortir de l'éditeur
                                </button>
                            </div>
                        ) : (
                            <div className={"editModeContent"}>
                                <button
                                    type="button"
                                    className="editorLauncher"
                                    onClick={() => {
                                        uiStore.openPanel();
                                        uiStore.isPanelExtended = true;
                                        ResizeGridLayout();
                                        widgetStore.updateAllWidgetStatic();
                                    }}
                                    aria-label="Ouvrir l’éditeur et la navigation des phidgets"
                                >
                                    <span className="editorLauncherIcon" aria-hidden="true">
                                        <DragDropSvg width={25} height={25} couleur={"#FBFDFE"}/>
                                    </span>
                                    <span className="editorLauncherCopy">
                                        <strong>Mes phidgets</strong>
                                        <small>Modifier l’écran</small>
                                    </span>
                                </button>
                            </div>
                        )
                    ) : null

                }

                {((['Mon écran', 'Mon premier écran'].includes(infosEcran.tot_nom)) && showModalBacASable) && (
                    <ModalPrimary textTitle={"Bienvenue sur Mon écran !"}
                                  textComment={"Quelques phidgets sont prêts à l'emploi pour faciliter votre prise en main. Glissez-déposez des widgets, configurez vos indicateurs et invitez vos collaborateurs depuis Mon Compte. À vous de jouer !"}
                                  textBtnCancel={"C'est parti !"} onCancel={() => {
                                      if (hideBacASablePermanently) {
                                          localStorage.setItem('seizo_bac_sable_' + infosEcran.id_totem, '1');
                                      }
                                      setShowModalBacASable(false);
                                  }}>
                        <label style={{display: 'flex', alignItems: 'center', gap: '8px', marginTop: '1rem', cursor: 'pointer'}}>
                            <input type="checkbox" checked={hideBacASablePermanently}
                                   onChange={(event) => setHideBacASablePermanently(event.target.checked)}/>
                            Ne plus afficher ce message pour cet écran
                        </label>
                    </ModalPrimary>
                )}


                <DragDropContext onDragEnd={handleOnDrop}>
                    {
                        createWidgetStore.isPanelNiveauxOpened ? (<SidebarNiveaux/>) : (
                            uiStore.isPanelOpened ? (
                                <Sidebar visible={true} viderTableau={() => {
                                }}/>
                            ) : null
                        )
                    }
                    {
                        uiStore.isCreationMode ? (
                            <CreateWidget/>
                        ) : uiStore.isConsultingMode ? (
                            <URLMetier/>
                        ) : uiStore.isConsultingIndicateurWidget ? (
                            <WidgetIndicateurNiveaux/>
                        ) : uiStore.isConsultingModeMessagesInterServices ? (
                            <ListeMessagesInterServices/>
                        ) : uiStore.isConsultingModePlanningActions ? (
                            <PlanningActions/>
                        ) : uiStore.isConsultingModeTableauBlanc ? (
                            <TableauBlanc/>
                        ) : uiStore.isConsultingModeRSP ? (
                            <RspPleinEcran/>
                        ) : uiStore.isConsultingConsignesWidget ? (
                            <WidgetConsignesContent/>
                        ) : uiStore.isParametresOpen ? (
                            <ParametragesSystemeHome/>
                        ) : uiStore.isConsultingPhotosWidget ? (
                            <WidgetBibliothequeImagesContent/>
                        ) : (
                            <NiveauFlash/>
                        )
                    }
                </DragDropContext>

                {
                    uiStore.displayEditMode ? (
                        uiStore.isPanelOpened ? (
                            <div className={"totemEditModeFooter"}>
                                <div className={"totemEditModeFooter2"}>
                                    {
                                        uiStore.showBtnDeleteWidget ? (
                                            <div className={"totemEditModeFooterBtnContent"}>
                                                {
                                                    uiStore.isDeleteModeWidget ? (
                                                        <div className={"totemEditModeFooterIsMode"}>
                                                            <button type={"button"}
                                                                    className={"totemEditModeFooterBtnBack"}
                                                                    onTouchStart={(event) => event.stopPropagation()}
                                                                    onClick={() => uiStore.closeDeleteModeWidget()}
                                                                    onTouchEnd={() => uiStore.closeDeleteModeWidget()}
                                                            >
                                                                Annuler
                                                            </button>
                                                            <button type={"button"}
                                                                    className={"totemEditModeFooterBtnDeleteAll"}
                                                                    onTouchStart={(event) => event.stopPropagation()}
                                                                    onClick={() => setShowModalDeleteAll(true)}
                                                                    onTouchEnd={() => setShowModalDeleteAll(true)}
                                                            >
                                                                Vider le contenu de l'écran
                                                            </button>
                                                        </div>

                                                    ) : (
                                                        <button type={"button"}
                                                                className={"totemEditModeFooterBtnDelete"}
                                                                onTouchStart={(event) => event.stopPropagation()}
                                                                onClick={() => uiStore.openDeleteModeWidget()}
                                                                onTouchEnd={() => uiStore.openDeleteModeWidget()}
                                                        >
                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M3.30907 16.1505L2.71824 4.33398H17.2824L16.6916 16.1505C16.6118 17.7471 15.294 19.0007 13.6953 19.0007H6.30532C4.7067 19.0007 3.3889 17.7471 3.30907 16.1505Z"
                                                                    stroke="#F82121" strokeWidth="2"/>
                                                                <path
                                                                    d="M6.83301 4H13.1663V3C13.1663 1.89543 12.2709 1 11.1663 1H8.83301C7.72844 1 6.83301 1.89543 6.83301 3V4Z"
                                                                    stroke="#F82121" strokeWidth="2"/>
                                                                <path d="M0.833008 4.16602H19.1663" stroke="#F82121"
                                                                      strokeWidth="2"/>
                                                                <path d="M12.5 9.16602V13.3327" stroke="#F82121"
                                                                      strokeWidth="2"/>
                                                                <path d="M7.5 9.16602V13.3327" stroke="#F82121"
                                                                      strokeWidth="2"/>
                                                            </svg>
                                                            Retirer des Phidgets
                                                        </button>
                                                    )
                                                }

                                            </div>
                                        ) : null
                                    }

                                </div>
                            </div>
                        ) : null
                    ) : null
                }

                <div className={"footer"}>
                    <div className={"help"} style={{ display: uiStore.isConsultingModePlanningActions ? 'none' : undefined }}>
                        <button type="button" className={`btnHelp${showAide ? ' isOpen' : ''}`}
                             onClick={() => setShowAide(!showAide)}
                             aria-expanded={showAide}
                             aria-controls={uiStore.isPanelOpened ? 'editor-help-panel' : undefined}
                             style={{
                                 backgroundColor: uiStore.isPanelOpened
                                     ? "var(--SEIZO-bleu, #00B0FF)"
                                     : "var(--SEIZO-jaune, #F8D541)",
                                 color: uiStore.isPanelOpened
                                     ? "#FFFFFF"
                                     : "#000000"
                             }}>
                            <span className={"icone"}>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M18.2309 26.48C18.0176 26.48 17.8309 26.4133 17.6709 26.28C17.5109 26.12 17.4309 25.92 17.4309 25.68C17.4309 25.4667 17.4309 25.2533 17.4309 25.04C17.4309 24.8267 17.4309 24.6133 17.4309 24.4C17.5376 23.36 17.8176 22.44 18.2709 21.64C18.7509 20.8133 19.2976 20.0667 19.9109 19.4C20.5509 18.7067 21.1776 18.0533 21.7909 17.44C22.4309 16.8267 22.9643 16.2267 23.3909 15.64C23.8443 15.0267 24.1109 14.4 24.1909 13.76C24.2709 12.9867 24.1109 12.3333 23.7109 11.8C23.3376 11.2667 22.8176 10.8667 22.1509 10.6C21.5109 10.3067 20.8309 10.16 20.1109 10.16C18.8576 10.16 17.8309 10.4667 17.0309 11.08C16.2309 11.6933 15.6843 12.68 15.3909 14.04C15.3109 14.36 15.1776 14.6 14.9909 14.76C14.8043 14.8933 14.5509 14.96 14.2309 14.96H10.8309C10.5909 14.96 10.3776 14.88 10.1909 14.72C10.0309 14.5333 9.95094 14.2933 9.95094 14C9.9776 12.9333 10.2176 11.9067 10.6709 10.92C11.1509 9.90667 11.8309 9 12.7109 8.2C13.6176 7.4 14.7109 6.77333 15.9909 6.32C17.2709 5.84 18.7376 5.6 20.3909 5.6C22.2043 5.6 23.7243 5.84 24.9509 6.32C26.2043 6.77333 27.1909 7.37333 27.9109 8.12C28.6576 8.86667 29.1909 9.68 29.5109 10.56C29.8309 11.4133 29.9776 12.2533 29.9509 13.08C29.8976 14.0933 29.6709 15 29.2709 15.8C28.8709 16.6 28.3776 17.3467 27.7909 18.04C27.2043 18.7067 26.6043 19.3733 25.9909 20.04C25.3776 20.68 24.8309 21.3333 24.3509 22C23.8976 22.6667 23.5909 23.3733 23.4309 24.12C23.3776 24.36 23.3376 24.6 23.3109 24.84C23.2843 25.0533 23.2576 25.2667 23.2309 25.48C23.1243 25.8 22.9909 26.0533 22.8309 26.24C22.6709 26.4 22.4443 26.48 22.1509 26.48H18.2309ZM18.1109 34C17.8443 34 17.6176 33.9067 17.4309 33.72C17.2443 33.5333 17.1509 33.3067 17.1509 33.04V29.56C17.1509 29.2667 17.2443 29.0267 17.4309 28.84C17.6176 28.6533 17.8443 28.56 18.1109 28.56H21.9909C22.2843 28.56 22.5243 28.6533 22.7109 28.84C22.8976 29.0267 22.9909 29.2667 22.9909 29.56V33.04C22.9909 33.3067 22.8976 33.5333 22.7109 33.72C22.5243 33.9067 22.2843 34 21.9909 34H18.1109Z"
                                        fill={uiStore.isPanelOpened ? ("white") : ("black")}/>
                                </svg>
                            </span>
                            <span className={"texte"}>{uiStore.isPanelOpened ? ("Aide Editeur") : ("Besoin d'aide")}</span>
                        </button>
                        <div className={"rectangle"} style={{
                            backgroundColor: uiStore.isPanelOpened
                                ? "var(--SEIZO-bleu, #00B0FF)"
                                : "var(--SEIZO-jaune, #F8D541)"
                        }}></div>

                        {showAide &&
                            (uiStore.isPanelOpened ? (
                                    <section className="editorHelpPanel" id="editor-help-panel" aria-label="Aide pour le mode édition">
                                        <header className="editorHelpHeader">
                                            <span className="editorHelpIcon" aria-hidden="true">
                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z"/>
                                                </svg>
                                            </span>
                                            <div className="editorHelpHeading">
                                                <span className="editorHelpEyebrow">Mode édition</span>
                                                <h2 className="editorHelpTitle">Composez votre écran</h2>
                                            </div>
                                            <button type="button" className="editorHelpClose" onClick={() => setShowAide(false)} aria-label="Fermer l’aide éditeur">
                                                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                                            </button>
                                        </header>
                                        <p className="editorHelpIntro">Ajoutez uniquement les informations utiles au terrain, puis organisez-les par simple glisser-déposer.</p>
                                        <ol className="editorHelpSteps">
                                            <li className="editorHelpStep"><span className="editorHelpStepNumber">1</span><div><strong>Ajoutez un phidget</strong><span>Utilisez Ajouter pour créer un nouveau bloc.</span></div></li>
                                            <li className="editorHelpStep"><span className="editorHelpStepNumber">2</span><div><strong>Placez-le sur le tableau</strong><span>Ouvrez Phidgets, puis faites glisser une carte disponible.</span></div></li>
                                            <li className="editorHelpStep"><span className="editorHelpStepNumber">3</span><div><strong>Configurez ou retirez</strong><span>Utilisez les actions de chaque carte pour l’adapter à votre besoin.</span></div></li>
                                            <li className="editorHelpStep"><span className="editorHelpStepNumber">4</span><div><strong>Terminez l’édition</strong><span>Sortez de l’éditeur pour retrouver votre tableau de pilotage.</span></div></li>
                                        </ol>
                                        <div className="editorHelpActions">
                                            <button type="button" className="editorHelpPrimary" onClick={openHelpPhidgets}>Ouvrir mes phidgets</button>
                                            <button type="button" className="editorHelpSecondary" onClick={openHelpCreation}>Ajouter un phidget</button>
                                        </div>
                                        <p className="editorHelpFooterNote">Les modifications de disposition sont enregistrées lorsque vous quittez l’éditeur.</p>
                                        <button type="button" className="editorHelpSecondary" onClick={exitEditorFromHelp} style={{marginTop: 10, width: '100%'}}>Sortir de l’éditeur</button>
                                    </section>
                                ) : (
                                    <div className={`aide_besoin_aide`}>
                                        <div className={"aide_bulle"}>
                                            <div className={"titre"}>D’autres questions ?</div>
                                            <div className={"description"}>
                                                Notre centre d’aide est en préparation afin de mieux vous accompagner.
                                            </div>
                                            <BtnPrimary children={"Centre d'aide"}
                                                        onClick={() => setShowHelpUnavailable(true)}/>
                                        </div>

                                        <div className={"aide_carre"}>
                                            <ContactForm/>
                                        </div>
                                    </div>
                                )
                            )
                        }
                        {showHelpUnavailable && (
                            <ModalPrimary
                                textTitle="Le centre d’aide se prépare"
                                textComment="Nous peaufinons cet espace pour mieux vous accompagner. Revenez vous connecter un peu plus tard : le centre d’aide sera bientôt disponible."
                                showValidateBtn={false}
                                textBtnCancel="Fermer"
                                onCancel={() => setShowHelpUnavailable(false)}
                            />
                        )}
                    </div>

                    <div className={"totemFooter"}>
                        <div className={"logo_version"}>
                            <LogoSeizoSSvg width="36" height="46"/>
                            <div className={"version"}>v2.13.9</div>
                        </div>

                        <div className={"content"} style={{display: "flex", alignItems: "center", gap: "0"}}>
                            <span className={"texte"}>
                                Vous êtes sur l'écran&nbsp;
                                <span className={"gras"}>{infosEcran?.tot_nom}.</span>
                            </span>
                            <div style={{width: "1px", height: "20px", backgroundColor: "#CBD5E1", margin: "0 12px", flexShrink: 0}}/>
                            <BtnSecondary onClick={backHome} children={"Revenir vers l'accueil"}/>
                        </div>
                    </div>
                </div>

                {
                    showModalDeleteAll ? (
                        <ModalPrimary
                            textTitle={"Êtes-vous sur de vouloir vider le contenu de l'écran ?"}
                            textComment={'Les Phidgets ne seront pas supprimés, ils seront toujours disponibles dans "Mes Phidgets".'}
                            textBtnValidate={"Vider l'écran"}
                            textBtnCancel={"Revenir"}
                            onCancel={() => setShowModalDeleteAll(false)}
                            onValidate={() => {
                                widgetStore.removeAllWidget();
                                uiStore.closeDeleteModeWidget();
                                setShowModalDeleteAll(false);
                            }}
                        />
                    ) : null
                }
            </div>) :
        (<Err403/>)
});
export default Dashboard;
